/**
 * Created by qinghai.peng on 18/07/17.
 */
import axios from 'axios'
import store from '../store'
import {getToken} from './cookie'
import router from '../router'
import Config from '../config'

const requestApi = axios;
const requestUrlArray = [];
axios.interceptors.request.use(config => {

    //请求超时时间1分钟， 单位毫秒
    config.timeout = 600000;
    // config.timeout = 59999;
    if(Config.http_header == null  || Config.http_header.length  == 0 || !Config.http_header.hasOwnProperty("ContentType")){
        Config.http_header['ContentType'] = 'application/json;charset:UTF-8'
    }

    //if(Config.http_header.length  > 0){
        for(let key in Config.http_header){
            config.headers[key] = Config.http_header[key]
        }
        /*config.headers = {
            'Content-type': Config.http_header_ContentType
        };*/
   /* }else{
        config.headers = {
            'Content-type': 'application/json;charset:UTF-8'
        };
    }*/

    if (store.getters.token) {
        config.headers['X-Token'] = getToken();
    }
    requestUrlArray.push(config.url);
    store.commit('MUTATION_V_LOADING', true);
    return config;
}, error => {
    return Promise.reject(error);
});
axios.interceptors.response.use(
    response => {
        // console.log(response)
		//alert("resp11133=="+response.status) 空

        /* if (response.data.code == '400' && response.data.message) {
            Config.MessageModal('error', response.data.message, 4000); 
        } */

        requestUrlArray.splice(0, 1);
        if (requestUrlArray.length === 0) {
            store.commit('MUTATION_V_LOADING', false);
        }
        if(Config.axios_response_body){
            return response.data.body === undefined ? response.data : response.data.body;
        }else{
            return response.data;
        }

    },
    error => {
		 //alert("resp2222==")
        requestUrlArray.splice(0, 1);
        if (requestUrlArray.length === 0) {
            store.commit('MUTATION_V_LOADING', false);
        }
		 
        let resp = error.response;
         //alert("resp=="+resp.status)
		  if (resp.status === 429) {
            router.push({path: '/login'});
			return
        }
		 if (resp.status === 405) {
            router.push({path: '/login'});
			return
        }
        if (resp.status === 504) {
            Config.NotificationModal('error', '系统提示', "服务器异常，请求超时！", 5000);
            router.push({path: '/login'});
            return Promise.reject(error.response);
        } else if (resp.status === 404) {
           /*  let msg = '';
            let url = error.response.data.path;
            if (error.response.data.body && error.response.data.body.message) {
                msg = error.response.data.body.message
            } else {
                msg = error.response.status  
            }
            Config.alert(msg + ' 您请求的资源 '+url+' 不存在!', '系统提示'); */

            router.push({path: '/login'});
            return Promise.reject(error.response);
        }
        if (error.response.data.message) {
            if (error.response.data.message === '会话超时') {
                sessionStorage.removeItem(Config.USER_NAME_KEY);
                router.push({path: '/login'});
                return Promise.reject(error.response);
            }
            Config.NotificationModal('error', '系统提示', error.response.data.message, 5000);
        } else {
            if (error.response.status >= 500) {
                if (error.response.data.body.message) {
                    // Config.NotificationModal('error', '系统提示', error.response.data.body.message, 5000);
                    Config.MessageModal('error', error.response.data.body.message, 4000);
                } else {
                    Config.NotificationModal('error', '系统提示', error.response.status + ' 服务器异常,请稍后再试!', 5000);
                }
            }
        }
        return Promise.reject(error.response);
    });

export default requestApi;



// WEBPACK FOOTER //
// ./src/api/build.js